import { travelGuideQueryKeys as e } from "./travelGuideQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { guestGuidesApi as n } from "@maat/api-main";
//#region src/travelGuides/useGuideShelvesQuery.ts
var r = () => t({
	queryKey: e.guestShelves(),
	fetchPage: (e) => n.shelves({ page: e }),
	key: "shelves"
});
//#endregion
export { r as useGuideShelvesQuery };
